import { tv } from "tailwind-variants";

export const list = tv({
    variants: {
        hasUnorderedList: {
            true: [
                "tw:[&_ul]:mb-6 tw:[&_ul]:list-none tw:[&_ul]:pl-6",
                "tw:[&_ul_li]:has-[a]:mt-2",
                "tw:[&_ul_li]:before:content-['■'] tw:[&_ul_li]:before:text-primary tw:[&_ul_li]:before:inline-block",
                "tw:[&_ul_li]:before:-ml-6 tw:[&_ul_li]:before:pr-3 tw:[&_ul_li]:before:-translate-y-1 tw:[&_ul_li]:before:align-middle"
            ]
        },
        hasOrderedList: {
            true: "tw:[&_ol]:mb-6 tw:[&_ol_li]:mb-2 tw:[&_ol]:list-decimal tw:[&_ol]:pl-6"
        }
    },

    defaultVariants: {
        hasOrderedList: false,
        hasUnorderedList: false
    }
});
